module.exports = __webpack_public_path__ + "media/images/top-1-share-income-74a0052037ef02023de8491069b8c64d.png";